import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
    borderRadius: '8px',
    width: '300px',
    height: '330px',
    overflow: 'hidden',
    boxShadow: theme.palette.shadow.cardBoxShadow,
    '& a': {
      textDecoration: 'none',
      height: '100%',
    },
    '&:hover': {
      boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.28)',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  alignment: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardInfo: {
    height: '180px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1.56rem',
    paddingRight: '1.56rem',
    paddingBottom: '1.56rem',
    paddingTop: '1.56rem',
  },
  imageContainer: ({ url, position }) => ({
    height: '150px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    backgroundImage: url && `url(${url})`,
    backgroundSize: 'cover',
    backgroundPosition: (position ? `${position.x} ${position.y}` : 'center'),
  }),
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
  topLine: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dateRange: {
    marginTop: '0.625rem',
    marginBottom: '0.625rem',
    '& span': {
      ...theme.typography.formTags,
      color: theme.palette.grey.dark,
    },
  },
  headline: {
    color: theme.palette.secondary.main,
  },
  tagsRow: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    top: '1.275rem',
    paddingLeft: '1.56rem',
    paddingRight: '1.56rem',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      top: '0.75rem',
      paddingLeft: '1.25rem',
      paddingRight: '1.25rem',
    },
  },
  tagsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
    },
  },
  tag: {
    ...theme.typography.formTags,
    padding: '5px 10px',
    borderRadius: '6px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '22px',
    marginBottom: theme.spacing(1),
  },
  fieldText: {
    fontWeight: '500',
    color: theme.palette.grey.dark,
    display: '-webkit-box',
    boxOrient: 'vertical',
    overflow: 'hidden',
    lineClamp: '5',
    height: '6.25em',
    lineHeight: '1.25em',
    textOverflow: 'ellipsis',
  },
  cta: {
    color: theme.palette.blue.main,
    fontWeight: 700,
    lineHeight: 1.75,
    marginTop: 'auto',
  },
}))

export default useStyles
